import { Dispatch, SetStateAction, useContext } from "react";

import { Grid } from "@mantine/core";
import { OrderForm } from "./components/OrderForm";
import { OrderSummary } from "./components/OrderSummary";
import { QuoteContext } from "@/features/form/context/QuoteContext";
import styles from "./styles.module.scss";
import { useMediaQuery } from "@mantine/hooks";
import { usePaymentForm } from "./hooks/usePaymentForm";

interface PaymentFormProps {
  style?: any;
  handleBackToQuote?: () => void;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

export function PaymentForm({
  style,
  handleBackToQuote,
  setIsLoading,
}: PaymentFormProps) {
  const { quoteItems, quoteId, planDurationDays } = useContext(QuoteContext);

  const { step, nextStep, shippingAmount, setShippingAmount } =
    usePaymentForm();

  const matches1440px = useMediaQuery("(max-width: 1440px)");

  return (
    <>
      <Grid
        style={style}
        className={styles.container}
        gutter={matches1440px ? 40 : 80}
      >
        <Grid.Col span={{ md: 6 }}>
          <button
            className={styles.buttonContainer}
            onClick={handleBackToQuote}
          >
            Voltar
          </button>

          <OrderForm
            activeStep={step}
            nextStep={nextStep}
            quoteId={quoteId}
            setShippingAmount={setShippingAmount}
            setIsLoading={setIsLoading}
          />
        </Grid.Col>
        <Grid.Col span={{ md: 6 }}>
          <OrderSummary
            quoteItems={quoteItems}
            shippingAmount={shippingAmount}
            planDurationDays={planDurationDays}
          />
        </Grid.Col>
      </Grid>
    </>
  );
}
